<template>
  <div class="bg-linear-gradiant d-flex align-items-center justify-content-center">
    <div id="global-loader" style="display: none">
      <div class="page-loader"></div>
    </div>

    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <div class="container">
        <div class="coming-soon">
          <!-- Page Wrapper -->
          <div class="Page-wrapper">
            <div class="row flex-wrap justify-content-center align-items-center">
              <div class="col-md-8 d-flex justify-content-end align-items-center mx-auto">
                <div
                  class="comming-soon-pg d-flex flex-column align-items-center justify-content-center"
                >
                  <div class="mb-4 p-4">
                    <img src="@/assets/img/logo.svg" alt="logo" class="img-fluid" />
                  </div>
                  <div>
                    <img
                      src="@/assets/img/bg/coming-soon.svg"
                      alt="image"
                      class="img-fluid"
                    />
                  </div>
                  <ul
                    class="d-inline-flex align-items-center justify-content-center mb-3"
                  >
                    <li class="me-sm-3 me-2">
                      <div class="d-flex flex-column align-items-center">
                        <div
                          class="d-flex counts-card align-items-center mb-2 justify-content-center flex-column border rounded bg-primary px-sm-4 py-sm-3 p-2"
                        >
                          <h3 class="days fs-sm-30 text-white fs-24">54</h3>
                        </div>
                        <p class="text-gray-9 fw-medium fs-16">Days</p>
                      </div>
                    </li>
                    <li class="text-gray fw-bold fs-30 me-sm-3 mb-4 me-2">:</li>
                    <li class="me-sm-3 me-2">
                      <div class="d-flex flex-column align-items-center">
                        <div
                          class="d-flex align-items-center counts-card mb-2 justify-content-center flex-column border rounded bg-primary px-sm-4 py-sm-3 p-2"
                        >
                          <h3 class="hours fs-sm-30 text-white fs-24">2</h3>
                        </div>
                        <p class="text-gray-9 fw-medium fs-16">Hours</p>
                      </div>
                    </li>

                    <li class="text-gray fw-bold fs-30 me-sm-3 mb-4 me-2">:</li>
                    <li class="me-sm-3 me-2">
                      <div class="d-flex flex-column align-items-center">
                        <div
                          class="d-flex align-items-center counts-card mb-2 justify-content-center flex-column border rounded bg-primary px-sm-4 py-sm-3 p-2"
                        >
                          <h3 class="minutes fs-sm-30 text-white fs-24">54</h3>
                        </div>
                        <p class="text-gray-9 fw-medium fs-16">Minutes</p>
                      </div>
                    </li>
                    <li class="text-gray fw-bold fs-30 me-sm-3 mb-4 me-2">:</li>
                    <li>
                      <div class="d-flex flex-column align-items-center">
                        <div
                          class="d-flex align-items-center counts-card mb-2 justify-content-center flex-column border rounded bg-primary px-sm-4 py-sm-3 p-2"
                        >
                          <h3 class="seconds fs-sm-30 text-white fs-24">10</h3>
                        </div>
                        <p class="text-gray-9 fw-medium fs-16">Seconds</p>
                      </div>
                    </li>
                  </ul>
                  <div>
                    <p class="fs-16 text-gray-9 text-center">
                      Please check back later, We are working hard to get <br />
                      everything just right.
                    </p>
                    <div class="subscribe-form">
                      <div class="mb-3 position-relative">
                        <p class="d-flex text-gray-9 text-center fw-medium fs-16 mb-3">
                          Subscribe to get notified
                        </p>
                        <div
                          class="bg-transparent border p-2 d-flex align-items-center rounded ps-0"
                        >
                          <input
                            type="email"
                            class="form-control bg-transparent border-0"
                            placeholder="Enter Your Email"
                          />
                          <a href="javascript:void(0);" class="btn btn-primary"
                            >Subscribe</a
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      class="d-flex flex-wrap justify-content-center align-items-center pb-4"
                    >
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary rounded-circle btn-icon btn-sm me-2 d-flex align-items-center justify-content-center"
                        ><i class="ti ti-brand-facebook fs-16"></i
                      ></a>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary rounded-circle btn-icon btn-sm me-2 d-flex align-items-center justify-content-center"
                        ><i class="ti ti-brand-twitter fs-16"></i
                      ></a>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary rounded-circle btn-icon btn-sm me-2 d-flex align-items-center justify-content-center"
                        ><i class="ti ti-brand-linkedin fs-16"></i
                      ></a>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary rounded-circle btn-icon btn-sm d-flex align-items-center justify-content-center"
                        ><i class="ti ti-brand-instagram fs-16"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Wrapper -->
        </div>
      </div>
    </div>
    <!-- /Main Wrapper -->
  </div>
</template>
